import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';
import moment from 'moment/moment';

export default function () {
  const pageable = usePageable();

  const filters = ref({
    reasonRequest: {value: null},
    startingAvailabilityDatetime: {value: null},
    endingAvailabilityDatetime: {value: null},
    'wishedMeetingAddress.city': {value: null},
    'wishedMeetingAddress.postcode': {value: null},
    status: {value: null}
  });


  function formatDateFilter(date) {
    if (!date) return null;
    return moment(this.end).format('YYYY-MM-DD');
  }


  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value.status?.value != null) {
      params['status'] = filters.value.status.value;
    }

    if (filters.value.reasonRequest?.value != null) {
      params['reasonRequest'] = filters.value.reasonRequest.value;
    }

    if (filters.value.startingAvailabilityDatetime?.value != null) {
      params['startingAvailabilityDatetime'] = filters.value.startingAvailabilityDatetime.value;
    }

    if (filters.value.endingAvailabilityDatetime?.value != null) {
      params['endingAvailabilityDatetime'] = filters.value.endingAvailabilityDatetime.value;
    }

    if (filters.value['wishedMeetingAddress.city']?.value != null) {
      params['city'] = filters.value['wishedMeetingAddress.city'].value;
    }

    if (filters.value['wishedMeetingAddress.postcode']?.value != null) {
      params['postcode'] = filters.value['wishedMeetingAddress.postcode'].value;
    }

    return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


